// extracted by mini-css-extract-plugin
module.exports = {"user_verification_overlay":"style_user_verification_overlay__gEVwf","user_verification_text":"style_user_verification_text__aZUv6","loading":"style_loading__k37_Q"};